import { TranslationContext } from 'contexts/translation-context';

import { useContext } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import diamondsBackground from 'assets/images/join/diamondsBackground.png';
import { BlueLink } from 'components/common/link';
import { PlanState } from '../reducers/plan';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${props => props.theme.colors.siteGrey};
  align-items: center;
  padding: 40px 0;
  max-width: 890px;
`;
const FirstText = styled.div`
  font-family: ${props => props.theme.fonts.montserratLight};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 30px;
  text-align: center;
  margin: 36px;
  @media (max-width: 999px) {
    font-size: 25px;
  }
`;
const SecondText = styled.div`
  font-family: ${props => props.theme.fonts.montserratLight};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 17px;
  @media (max-width: 999px) {
    font-size: 15px;
  }
  text-align: center;
  white-space: break-spaces;
`;
const StyledLink = styled(BlueLink)`
  font-family: ${props => props.theme.fonts.montserratLight};
  font-size: 17px;
  @media (max-width: 999px) {
    font-size: 15px;
  }
`;
const StyledDiv = styled.div`
  margin-top: 36px;
  border: 2px solid ${props => props.theme.colors.lightGrey};
  background-color: ${props => props.theme.colors.white};
  width: 668px;
  @media (max-width: 999px) {
    width: auto;
  }
  height: 98px;
  padding-top: 20px;
  border-radius: 5px;
`;
const ImgContainer = styled.div`
  padding: 15px;
  align-self: flex-end;
`;

const StyledImage = styled.img`
  mix-blend-mode: darken;
  max-width: 100%;
  height: 380px;
`;

export const SuccessPageForPriceList = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  const paymentStatus = useSelector((state: { plan: PlanState }) => state.plan?.paymentStatus);
  const isAchPaymentInVerification = paymentStatus === 'AchPaymentInVerification';

  return (
    <Container>
      {isAchPaymentInVerification ? (
        <>
          <FirstText>{TRANSLATION_TEXT.ach_payment_received_title}</FirstText>
          <SecondText>{TRANSLATION_TEXT.ach_payment_received_body}</SecondText>
          <SecondText>{TRANSLATION_TEXT.ach_payment_received_email_notice}</SecondText>
        </>
      ) : (
        <>
          <FirstText>{TRANSLATION_TEXT.thank_you_for_subscribing_price_list}</FirstText>
          <SecondText>{TRANSLATION_TEXT.you_will_receive_an_email_1}</SecondText>
          <SecondText>{TRANSLATION_TEXT.you_will_receive_an_email_2}</SecondText>
        </>
      )}
      <StyledDiv>
        <SecondText>{TRANSLATION_TEXT.calculate_diamond_prices_on_the_go}</SecondText>
        <SecondText>
          {`${TRANSLATION_TEXT.download_the_rapnet_app} `}
          <StyledLink
            to={'https://apps.apple.com/il/app/rapnet-the-diamond-market/id530519916'}
          >{`App Store`}</StyledLink>
          {` or `}
          <StyledLink
            to={'https://play.google.com/store/apps/details?id=com.rapnet&hl=en'}
          >{`Google Play`}</StyledLink>
        </SecondText>
      </StyledDiv>
      <ImgContainer>
        <StyledImage src={diamondsBackground} />
      </ImgContainer>
    </Container>
  );
};
export default SuccessPageForPriceList;
